import React from 'react';
import Div from '../../Element/Div/Div';
import Flex from '../../Flex/Flex';
import PricingText from '../../Typography/PricingText/PricingText';
import SmallText from '../../Typography/SmallText/SmallText';
import { CreateProps } from '../../../types/utils/CreateProps';
import styles from './CardPrice.module.scss';
import Typography from '../../Typography/Typography';
import Element from '../../Element/Element';
import Skeleton from '../../Skeleton/Skeleton';

export type CardPriceProps = CreateProps<
  {
    /** Show price in loading state */
    loading?: boolean;
    /** Prefix for the price, e.g. 'starting from' */
    prefix?: string;
    /** Value for the price */
    value: string | number;
    /** Currency, by default it's € */
    unit?: string;
    /** Normal price use with discounted price */
    normalPrice?: {
      /** Supporting prefix text, e.g. 'norm.' is also default prefix */
      prefix?: string;
      /** Value for the price */
      value: string | number;
      /** Postfix text can be  symbols or currency, e.g. ',-' */
      postfix?: string;
    };
    /** Alternate way of paying for example monthly installment */
    priceVariation?: JSX.Element | string;
  },
  typeof Div
>;
// Alias for backwards compatibility
export type PriceAttributes = CardPriceProps;

const CardPrice: React.FunctionComponent<CardPriceProps> = ({
  loading,
  value,
  unit = '€',
  normalPrice,
  priceVariation,
  prefix,
  ...props
}) => {
  if (loading) {
    return <Skeleton width={100} height="sm" />;
  }

  return (
    <Element tagName="footer" {...props} className={styles.cardPrice}>
      {prefix && (
        <Typography
          tagName="div"
          color="black"
          className={styles.cardPrice_prefix}
        >
          {prefix}
        </Typography>
      )}
      <Div occupyHorizontalSpace>
        <Flex>
          <PricingText
            size="sm"
            color="black"
            className={styles.cardPrice_priceValue}
          >
            {value} {unit}
          </PricingText>
          {normalPrice && (
            <SmallText className={styles.cardPrice_normalPrice} color="gray500">
              {normalPrice.prefix ? normalPrice.prefix : 'norm.'}{' '}
              {normalPrice.value}
              {normalPrice.postfix}
            </SmallText>
          )}
        </Flex>
      </Div>
      {typeof priceVariation === 'string' ? (
        <SmallText className={styles.cardPrice_priceVariation} color="black">
          {priceVariation}
        </SmallText>
      ) : (
        priceVariation
      )}
    </Element>
  );
};

export default CardPrice;
